import { useState } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckFormInput from '../../forms/TextInputField/components/LaunchdeckFormInput';

export default function SetNewOrgUserPasswordForm(props) {

	const { handleSetPassword } = props || {};
	const [localState, setLocalState] = useState({
		inputPassword: "",
		repeatPassword: "",
		showLoader: false,
		showValidationError: false,
	})

	const onPressEnterAndLogin = (e) => {
		if (e.key === 'Enter') {
			submitSetNewPassword();
		}
	}

	const handleChange = (event) => {
		const value = event.target.value;
		setLocalState(prevState => ({
			...prevState,
			[event.target.name]: value,
			showValidationError: false
		}));
	}

	const submitSetNewPassword = () => {
		const { inputPassword, repeatPassword } = localState;
		const { resetPasswordToken } = props;
		const sameInputs = ((inputPassword && inputPassword.length > 5) && (inputPassword === repeatPassword)) ? true : false;

		if (sameInputs) {
			handleSetPassword({ useCase: "set-new-user-password", inputPassword, resetPasswordToken })

			setLocalState(prevState => ({
				...prevState,
				showLoader: true
			}));
		}

		if (!sameInputs) {
			setLocalState(prevState => ({
				...prevState,
				showValidationError: true
			}));
		}

	}


	const { showValidationError, showLoader, inputPassword, repeatPassword } = localState;

	if (showLoader) {
		return (
			<PageLoader />
		)
	} else {
		return (
			<Box my='3%' w={['80%', '60%']}>

				<Flex w='100%' maxW='30em' direction='column' align='center' gap='1.25em' onKeyDown={(e) => onPressEnterAndLogin(e)}>
					<LaunchdeckFormInput
						label='Password'
						name={'inputPassword'}
						onChange={handleChange}
						value={inputPassword}
						type='password'
					/>

					<LaunchdeckFormInput
						label='Confirm password'
						name={'repeatPassword'}
						onChange={handleChange}
						value={repeatPassword}
						type='password'

						errorLogic={showValidationError}
						errorMessage={`Your confirmation password did not match, or needs to be more than 6 characters`}
					/>
					<Flex w='100%' mt='1em'>
						<LaunchdeckButton bg='brand.500' color='white' w='100%' onClick={() => submitSetNewPassword()} label='Set Password' />
					</Flex>
				</Flex>
			</Box>
		)
	}
};